import { render, staticRenderFns } from "./case-header.vue?vue&type=template&id=6b2a0702&"
import script from "./case-header.vue?vue&type=script&lang=js&"
export * from "./case-header.vue?vue&type=script&lang=js&"
import style0 from "./case-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports